import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { pb } from "../services/pocketbase";

const TournamentParticipants = ({ open, onClose, participants }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      sx={{ zIndex: 99 }}
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Event Participants
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {participants?.length > 0 ? (
          <List>
            {participants.map((participant, index) => (
              <ListItem key={index}>
                <ListItemAvatar>
                  <Avatar
                    src={
                      participant.expand?.user?.avatar
                        ? `${pb.baseUrl}/api/files/users/${participant.expand.user.id}/${participant.expand.user.avatar}`
                        : null
                    }
                    imgProps={{
                      crossOrigin: "anonymous",
                      referrerPolicy: "no-referrer",
                    }}
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Typography component="span">
                        {participant.expand?.user?.username || "Unknown User"}
                      </Typography>
                      {participant.expand?.user?.discord_id && (
                        <Typography
                          component="span"
                          color="text.secondary"
                          sx={{
                            cursor: "pointer",
                            "&:hover": {
                              textDecoration: "underline",
                            },
                          }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              participant.expand.user.discord_id
                            );
                          }}
                        >
                          (Discord ID: {participant.expand.user.discord_id})
                        </Typography>
                      )}
                    </Box>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography>No participants yet</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TournamentParticipants;
